<template>
  <swiper-content>
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout">
          <img
            src="addons/appletv.svg"
            class="header-image"
            style="max-height: 7vh"
          />

          <h2>Enjoy Apple Originals, only on Apple TV+.</h2>
          <p>
            Catch award-winning series, dramas, documentaries, kids’
            entertainment and more.
          </p>

          <p class="small">T&amp;Cs apply.</p>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout">
          <img src="addons/booth-2-header4.svg" class="header-image" />

          <h2>Listen to 70 million songs ad-free.</h2>
          <p>
            Stream on the go and enjoy your favourite tracks data-free across
            all your Apple devices.
          </p>
          <a
            target="_blank"
            href="https://www.singtel.com/personal/products-services/lifestyle-services/apple-music-activate?utm_source=virtual-store&utm_medium=virtual-store&utm_term=apple&utm_content=lifestyle-hotspot&utm_campaign=iphone-2020-launch"
            class="st-button-red-outline page-button-bottom"
          >
            Find out more
          </a>
          <p class="small">T&amp;Cs apply.</p>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout">
          <img src="addons/booth-2-header3.svg" class="header-image" />

          <h2>CAST a wider search for your entertainment.</h2>
          <p>From LIVE TV to on-demand shows, find it all on CAST.</p>

          <a
            target="_blank"
            href="https://cast.singtel.com/?utm_source=unboxed&utm_medium=direct&utm_campaign=05-10unboxed"
            class="st-button-red-outline page-button-bottom"
          >
            Find out more
          </a>
          <p class="small">T&amp;Cs apply.</p>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout">
          <img
            src="addons/booth-2-header1.svg"
            class="header-image booth1-header1"
            style="max-width: 100% !important"
          />
          <h2>A safer, contactless way to pay.</h2>
          <p>
            Enjoy the benefits of Singtel Dash using Apple Pay. Make easy,
            secure payments that will earn you reward points with an all-in-one
            mobile wallet.
          </p>
          <a
            target="_blank"
            href="https://dash.com.sg/?utm_source=virtual-store&utm_medium=virtual-store&utm_term=apple&utm_content=lifestyle-hotspot&utm_campaign=iphone-2020-launch"
            class="st-button-red-outline page-button-bottom"
          >
            Find out more
          </a>
          <p class="small">T&amp;Cs apply.</p>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout">
          <img src="addons/booth-2-header2.svg" class="header-image" />
          <h2>Walk your way to free data and more.</h2>
          <p>
            Get FREE data and lifestyle vouchers with every step! Sync your
            steps daily to earn points and redeem monthly rewards.
          </p>
          <a
            target="_blank"
            href="https://www.singtel.com/personal/products-services/lifestyle-services/stepup?utm_source=unboxed&utm_medium=direct&utm_campaign=05-10unboxed"
            class="st-button-red-outline page-button-bottom"
          >
            Find out more
          </a>
          <p class="small">T&amp;Cs apply.</p>
        </div>
      </div>
    </swiper-slide>
  </swiper-content>
</template>
<script>
import "swiper/swiper-bundle.css";

export default {
  //https://github.com/surmon-china/vue-awesome-swiper
  name: "AddonsPage2",
};
</script>

<style scoped></style>
